<template>
  <div>
    Filter: <input v-model="liveFilterQuery" v-on:keyup="updateFilter()">
    <a :href="$voidHref" v-on:click="loadData()">🔄 Refresh Data</a>
    <DistributorSelector v-model="distributor" />
    <a :href="$voidHref" v-on:click="pushDistributor()">Push To All</a>
    <div v-if="inventory.length === 0">
      <!-- Placeholder while loading -->
      Loading...
      <br><br><br><br><br><br>
    </div>

    <table v-if="inventory.length > 0" style="width:500px;">
      <tr>
        <th>&nbsp;</th>
        <th v-for="key in columnNames" :key="key" @click="toggleSort(key)">
          {{key}}
        </th>
      </tr>
      <InventoryPricingCRUDRow v-for="(row, index) in sortedIventory" 
      :row="row" 
      :key="index" 
      :location="location"
      :departments="departments"/>
      
    </table>
  </div>
</template>

<script>
import localstorageMixin from '@/mixins/localstorageMixin.js'
import InventoryPricingCRUDRow from './InventoryPricingCRUDRow.vue'
import _ from 'lodash'
import DistributorSelector from './DistributorSelector.vue'

export default {
  name : 'InventoryPricingCRUD',
  mixins: [localstorageMixin],
  components: {InventoryPricingCRUDRow, DistributorSelector},
  props: ['location', 'departments'],
  data () { return {
    ls: {
      filterQuery: "Vype"
    }, 
    distributor: undefined,
    sortKey:'ItemName',
    willSortAsc: true,
    liveFilterQuery: undefined,
    inventory: [],
    inventorySkus: [],
    inventorySkusObject: {},
    columnNames: ['ItemNum', 'ItemName', 'Dept', 'Price', 'Cost', 'Last Sold', 'Distributor'],
    pathNames: ['ItemNum', 'ItemName', 'department.Description', 'Price', 'Cost', 'Last_Sold', 'inventoryJson.Distributor'],
    } 
  },
  async created () {
    this.loadData();
    this.liveFilterQuery = this.ls.filterQuery
  }, 
  watch : {
    'location': 'loadData',
  },
  methods : {
    loadData : function(){
      this.inventory = [];
      
      const options = {attributes:['ItemNum', 'ItemName', 'Dept_ID', 'Price', 'Cost', 'Last_Sold']}
      options.include = [
        { 
          model: 'departments', attributes: ['Description'], required : true, include:['category'],
          where: {SubType: 'CIGS'}
        },
        { model: 'inventoryJson',},
      ]
      this.$axios.get(`/api/${this.location}/inventory`, {params:options}).then((r)=>{
        let sorted = r.data.sort((a,b)=>a.Dept_ID > b.Dept_ID)
        const meta = {isEditing:false, showAdvanced:false}
        this.inventory = sorted.map(row=>({meta:{...meta}, data:row}))
        this.inventory.forEach(r => r.data.inventoryJson = r.data.inventoryJson === null ? {Distributor:{}, JSON:{}} : r.data.inventoryJson)
      });
    },
    pushDistributor: async function(){
      if(confirm(`Are you sure you want to push ${this.distributor} to all?`)){

        for (let i = 0; i < this.filteredInventory.length; i++) {
          const row = this.filteredInventory[i];
          const updateData = {
            Store_ID: '1001', 
            ItemNum : row.data.ItemNum, 
            Distributor: this.distributor,
          }
          await i_axios.patch(`/api/${this.location}/inventoryJson`, updateData)
          row.data.inventoryJson.Distributor = this.distributor
          
        }
      }
    },
    updateFilter: _.debounce(function(){
      this.ls.filterQuery = this.liveFilterQuery
    }, 400),
    toggleAdvanced: function(row){
      row.meta.showAdvanced = !row.meta.showAdvanced;
    },
    willEdit: function(row){
      console.log("edit", row)
      row.meta.isEditing = true;
      row.meta.before = {...row.data};
    },
    saveEdit: function(row){
      console.log("save edit", row);
      row.meta.after = {...row.data};
      row.meta.isEditing = false;
      console.log(row.meta.before, row.meta.after)
      
      let updateData = {}
      let changedKeys = Object.keys(row.meta.before).filter(k=>row.meta.before[k]!==row.meta.after[k])
      changedKeys.forEach(r=>updateData[r]=row.meta.after[r])

      i_axios.put(`/api/${this.location}/inventory/${row.data.ItemNum}`, updateData).then((r)=>{
        //Should Do Something Here
        console.log(r)
      });
    },
    toggleSort: function(key){
      this.willSortAsc = this.sortKey === key ? !this.willSortAsc : this.willSortAsc
      this.sortKey = key
    }
  },
  computed: {
    filteredInventory: function(){
      const result = this.inventory.filter(r=>{
        return r.data.ItemName.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        // r.data.department.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        // r.data.department.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        `${r.data.Vendor_Part_Num}`.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        `${r.data.ItemNum}`.toLowerCase().includes(this.ls.filterQuery.toLowerCase())  ||
        r.meta.isEditing 
        // r.data.department.category.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase())
        })
      return result;
    },
    sortedIventory: function(){
      const key = this.pathNames[this.columnNames.indexOf(this.sortKey)]
      return this.$util.sortAscForKeyPath(this.filteredInventory, `data.${key}`, this.willSortAsc, true)
    }
  }
}
</script>

<style scoped>
tr:active, .table-striped tr:active:nth-child(even) {
  color: inherit !important;
  background-color: inherit !important;
}
</style>
